__turbopack_context__.v({
  "image": "projectsGrid-module-scss-module__SUA_LW__image",
  "image_wrapper": "projectsGrid-module-scss-module__SUA_LW__image_wrapper",
  "main": "projectsGrid-module-scss-module__SUA_LW__main",
  "noResults": "projectsGrid-module-scss-module__SUA_LW__noResults",
  "project": "projectsGrid-module-scss-module__SUA_LW__project",
  "project_title": "projectsGrid-module-scss-module__SUA_LW__project_title",
  "tagline": "projectsGrid-module-scss-module__SUA_LW__tagline",
  "wrapper": "projectsGrid-module-scss-module__SUA_LW__wrapper",
});
